import axios from "axios";
import Swal from "sweetalert2";
import CommonHeader from "../utils/commonHeader";
import GenerateURN from "../utils/generateUrn";
import { encryptWithKey } from "../utils/encryption/aes";
import { encryptSha } from "../utils/encryption/sha";

const getBaseURL = (page_type) => {
  if (page_type === "SESSION_INIT") {
    return process.env.REACT_APP_INIT_API;
  }
  return process.env.REACT_APP_KAWACH_GATEWAY_URL;
};

// Function to create an interceptor with dynamic baseURL
const EncrptionInterceptor = (page_type = null) => {
  const instance = axios.create({
    baseURL: getBaseURL(page_type),
    timeout: 30000,
  });

  instance.interceptors.request.use(async (config) => {
    config.headers["counterid"] = 0;
    config.headers["clientid"] = process.env.REACT_APP_CLIENT_ID;
    config.headers["urn"] = GenerateURN();
    config.headers["sessionId"] = localStorage.getItem("authToken");
    config.headers["agentId"] = localStorage.getItem("agentId");
    config.headers["userId"] = localStorage.getItem("userId");
    config.headers["userid"] = localStorage.getItem("userId");
    try {
      const bearerData = await CommonHeader(page_type);
      config.headers["bearerData"] = bearerData.bearerData;
    } catch (error) {
      console.error("Error fetching bearerData:", error);
    }

    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    // Encrypt POST data
    if (config.method === "post" && config.data) {
      try {
        const encrypted = await encryptWithKey(JSON.stringify(config.data));
        const encryptedKeyBase64 = encryptSha(encrypted.key);

        config.data = {
          data: encrypted.data,
          key: encryptedKeyBase64,
        };
      } catch (error) {
        console.error("Encryption failed:", error);
        return Promise.reject(error);
      }
    }

    return config;
  });

  instance.interceptors.response.use(undefined, (error) => {
    Swal.fire("Error", error.message, "error");
    return Promise.reject(error);
  });

  return instance;
};

export default EncrptionInterceptor;
